// TODO: Import from root sydle-one-components/, waiting for issue 1849 ONE
import type { OrganizationConfigs } from '@sydle/sydle-one-components/dist/types/models/OrganizationConfigs';
import type { OrganizationAPI, UIApiConfig } from '@sydle/ui-api';
import { getAPI } from '@sydle/ui-api';
import { getConfig } from '@sydle/ui-utils';
import type { SupportedLanguagesCode } from './api/SupportedLanguagesCode';
import type { PortalNavigator } from './portal/PortalNavigator';

export interface ServiceDeskConfig {
  searchRedirectURL: string;
  orgConfig: OrganizationConfigs;
  reCAPTCHASiteKey: string;
  recoverPassword: boolean;
  navigator?: PortalNavigator;
  addtionalDescriptionAuthentication?: string;
  addtionalDescriptionAuthentication__i18n?: { [language in SupportedLanguagesCode]: string };
  useNewBPM: boolean;
  saveFormDrafts: boolean;

  // PBH fields
  dialogLoginTitle?: string;
  dialogLoginTitle__i18n?: { [language in SupportedLanguagesCode]: string };
  auth?: { [key: string]: any };
  maxLevelToc?: number;
  autoRedirectCustomLogin?: boolean;
}

export function getServiceDeskConfig(): ServiceDeskConfig | null {
  if (!getConfig<ServiceDeskConfig>('service-desk-components')) {
    throw new Error('');
  }

  return getConfig<ServiceDeskConfig>('service-desk-components');
}

export async function getOrganizationConfig(): Promise<OrganizationConfigs | undefined> {
  const serviceDeskConfig = getConfig<ServiceDeskConfig>('service-desk-components');
  const orgIdentifier = getConfig<UIApiConfig>('ui-api')?.ORGANIZATION_IDENTIFIER;
  const orgConfig = serviceDeskConfig?.orgConfig;

  if (!orgConfig && orgIdentifier) {
    await getAPI<OrganizationAPI>('organizationAPI')
      ?.getConfigs({
        _id: orgIdentifier,
      })
      .then(({ data, error }) => {
        if (data && serviceDeskConfig) {
          serviceDeskConfig.orgConfig = data;
        } else if (error) {
          const errorMessage =
            error?.data?.generalMessages?.length > 0 ? error.data.generalMessages[0].text : JSON.stringify(error);
          console.error(`Error trying to get organization config: ${errorMessage}`);
        }
      });
  }

  return getConfig<ServiceDeskConfig>('service-desk-components')?.orgConfig;
}
